import React from 'react';
import styled from 'styled-components';
import media from "../../helpers/media";

export const Popup = ({ header, text, closePopup }) => (
    <Container onClick={closePopup}>
        <Body>
            <Header>{header}</Header>
            <span>Hello Dear User,</span>
            <span style={{ textAlign: "justify" }}>{text}</span>
            <CloseIcon onClick={closePopup}>x</CloseIcon>
        </Body>
    </Container>);

const Container = styled.div`
    position: fixed;  
    width: 100%;  
    height: 100%;  
    top: 0;  
    left: 0;  
    right: 0;  
    bottom: 0;  
    margin: auto;  
    background-color: rgba(0,0,0, 0.5);  
`;

const Header = styled.span`
    font-size:20px;
    font-weight:bold;
    margin:10px 0 10px 0;
`;

const Body = styled.div`
    margin: 70px auto;
    padding: 20px;
    background: #e8e6e6;
    border-radius: 5px;
    width: 70%;
    position: relative;
    transition: all 5s ease-in-out;
    display:flex;
    flex-direction:column;
    @media ${media.tablet}{
        width:30%;
    }
`;

const CloseIcon = styled.a`
    position: absolute;
    cursor: pointer;
    top: 4px;
    right: 15px;
    transition: all 200ms;
    font-size: 30px;
    font-weight: bold;
    text-decoration: none;
    color: #333;
`;